<title>{{ iagPortalLoggingInPage.htmlTitle }}</title>
<app-logging-in-card [loggingInCards]="iagPortalLoggingInPage.loggingInCards"></app-logging-in-card>
<app-section [sections]="iagPortalLoggingInPage.sections"></app-section>
